import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
import { MainService } from "../../../services/main.service";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import * as S3 from "aws-sdk/clients/s3";

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.scss']
})
export class EmpresasComponent implements OnInit {
  bucket: S3 = new S3({
    accessKeyId: "AKIAUT7IXVID4CI4XZVD",
    secretAccessKey: "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",
    region: "us-east-1"
  });
 /*  Para el modal */
 @ViewChild('dialog', {static: true}) dialog: ElementRef;
 spinerEdit = false;
 frmEmpresa: FormGroup;
 submitted = false;
 imagen: any = [""];
 listaIMG: any[] = [];
 ListaFotos: any = [""];
 loading = false;

 /*****/
 settings = {
   hideSubHeader: true,
   actions: {
     delete: false,
     edit: false,
     add: false,
     filter: false,
     custom: [
       {name: 'edit', title: '<i class="nb-compose"></i> ',},
       {name: 'delete', title: '<i class="nb-trash"></i> ',}
      ],
   },
   columns: {
    codigo_empresa: {title: 'Cod Empresa'},
    nombre_empresa: {title: 'Nombre'},
    nit_empresa: {title: 'Nit'},
    ciudad_empresa: {title: 'Ciudad'},
    contacto_empresa: {title: 'Contacto'}
   }
 };

 datos: any[];
 LastID: any;
 ListType: any[];
 padre_Select = false;
 Cod_padre: any;
 public source: LocalDataSource;
 constructor(private toastrService: NbToastrService,
  public router: Router,
  private dialogService: NbDialogService,
  public mainService: MainService,
  private rutaActiva: ActivatedRoute,
  public fb: FormBuilder) {
   this.getEmp();
   this.frmEmpresa = this.fb.group({
    tipo: ['', [Validators.required]],
    nit: [''],
    padre: [''],
    nombre: [''],
    ciudad: [''],
    contacto: [''],
    email: [''],
    pagina: [''],
    telefonoA: [''],
    telefonoB: [''],
    direccion: [''],
});
 }

 ngOnInit() {
 }
 getEmp() {
  this.mainService.get("tadmEmpresa").subscribe(result => {
    if (result) {
      console.log(result);
      this.LastID= result;
      this.datos = result;
      this.source = new LocalDataSource(this.datos);
    } else {
      console.log("Error al insertar en Sql");
    }
  });
}
get valoresCrear() {
  return this.frmEmpresa.controls;
}
callType(typeEmp){
  console.log(typeEmp);
switch(typeEmp) {
  case 'Empresa':
    this.mainService.get('tadmSelectType/Grupo').subscribe(value => {
      console.log(value);
      this.ListType = value;
      this.padre_Select = true;
      console.log(this.padre_Select)
    })
    break;
    case 'Predio':
      this.mainService.get('tadmSelectType/Empresa').subscribe(value => {
        console.log(value);
        this.ListType = value;
        this.padre_Select = true;
        console.log(this.padre_Select)
      })
    break;
  default:
    // code block
  }
}
 crear() {
   this.openDialogSave(this.dialog);
 }

 openDialogSave(dialog) {
   this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
 }

 accion() {
   this.spinerEdit = true;
   const TIME_IN_MS = 3000;
   setTimeout(() => {
     this.spinerEdit = false;
     this.showToast('top-right', 'success', 'Éxito!', 'Se ejecuto éxito!');
     const element: HTMLElement = document.getElementById('btn-close') as HTMLElement;
     element.click();
   }, TIME_IN_MS);
 }
 readUrl(event: any) {
  this.imagen = event.target.files[0];
  console.log(this.imagen);
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    reader.onload = (event: ProgressEvent) => {
      let img = { src: (<FileReader>event.target).result };
      this.listaIMG.push(img);
      //this.listaIMG[0].src = (<FileReader> event.target).result;
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}
makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
 /** Toas **/
 showToast(position, status, titulo, mensaje) {
   this.toastrService.show(
     mensaje,
     titulo,
     { position, status });
 }
 onCustom(event) {
  console.log(event);
  switch (event.action) {
      case 'edit':
        console.log(event.data.cod_empresa)
          this.verEmpresa(event.data.cod_empresa);
          break;
      case 'delete':
          this.eliminar(event.data);
          break;

  }
}
verEmpresa(id) {
        this.router.navigate(['dashboard/editEmpresas', id]);
}

eliminar(data) {         
  this.loading = true;       
  this.mainService.delete('tadmEmpresa/'+ data.cod_empresa).subscribe(result => {
      console.log(result);
      if (result.deleted) {
          console.log('Se ha eliminado');
          this.getEmp();
          this.loading = false;       
          this.showToast('top-right', 'success', 'Success!', 'It was deleted');

      } else {
          console.log('Error');
          this.showToast('top-right', 'warning', 'Error!', 'Error deleting!');
      }
  });
   }
   DeleteIMG() {
    this.listaIMG = [];
  }
  save() {
    this.loading = true;
    var params = {
      Bucket: "printech-resources",
      ACL: "public-read",
      Key: this.makeid(8) + this.imagen.name.trim(),
      ContentType: this.imagen.type,
      Body: this.imagen
    };
    var options = {
      // Part Size of 10mb
      partSize: 10 * 1024 * 1024,
      queueSize: 1,
      // Give the owner of the bucket full control
      ACL: "public-read"
    };
    const self = this;
    var uploader = this.bucket.upload(params, options, function(err, data) {
      if (err) {
        console.log("PERDIDAS");
        this.loadingImage = false;
      }
      console.log("SUCCESS");
      console.log(data);
      self.ListaFotos[0] = data.Location.toString();
      console.log(self.ListaFotos);
      self.saveEmp();
    });
    uploader.on("httpUploadProgress", function(event) {
      console.log("UPDATE");
      console.log(event);
      var total = (event.loaded * 100) / event.total;
      console.log(total);
    });
    return;
  }
   saveEmp() {
    this.submitted = true;
    if (this.frmEmpresa.invalid) {
        return false;
    }
    //this.spinner.show();
    let emp = this.frmEmpresa.value;
    console.log(emp);
    if(this.frmEmpresa.value.padre == ''){
      this.Cod_padre= 0;
    }else{
      this.Cod_padre= this.frmEmpresa.value.padre;
    }
    let insert = {
      padre: this.Cod_padre,
      pais:'Colombia',
      cod_empresa: JSON.parse(this.LastID.pop().cod_empresa+1),
      tipo: emp.tipo,
      nit_empresa: emp.nit,
      nombre_empresa: emp.nombre,
      ciudad_empresa: emp.ciudad,
      contacto_empresa: emp.contacto,
      email_empresa: emp.email,
      pagina_web_empresa: emp.pagina,
      telefono1_empresa: emp.telefonoA,
      telefono2_empresa: emp.telefonoB,
      direccion_empresa: emp.direccion,
      id_imagen_mongo_empresa: this.ListaFotos[0],
    }
    console.log(insert);
    this.mainService.post('tadmEmpresa', insert).subscribe(result => {
        console.log(result);
        if (result) {
            console.log('Se ha insertado');
            this.frmEmpresa.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.showToast('top-right', 'success', 'Success!', 'It was created successfully!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            this.getEmp();
            this.loading = false;
            element.click();
            return true;

        } else {
            console.log('Error');
            this.frmEmpresa.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.loading = false;
            this.showToast('top-right', 'warning', 'Error!', 'Error creating!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            element.click();

            return false;
        }
    });
}
}
